import React, { useEffect, useRef, useState } from "react";
import "./TopBar.css";

import hudIdleImg from "../../assets/img/hud_score1.png";
import hudChangeImg from "../../assets/img/hud_score2.png";

import hudTimerIdle from "../../assets/img/hud_timer1.png";
import hudTimerAlert from "../../assets/img/hud_timer2.png";

export default function TopBar({
  title,
  score = 0,
  timeLeft = 0,
  changeDurationMs = 700,
  timerAlertThreshold = 10
}) {
  const prevScoreRef = useRef(score);
  const scoreTimeoutRef = useRef(null);
  const [hudSrc, setHudSrc] = useState(hudIdleImg);
  const [isScoreChanging, setIsScoreChanging] = useState(false);

  useEffect(() => {
    if (prevScoreRef.current !== score) {
      if (scoreTimeoutRef.current) clearTimeout(scoreTimeoutRef.current);

      setHudSrc(hudChangeImg);
      setIsScoreChanging(true);

      scoreTimeoutRef.current = setTimeout(() => {
        setHudSrc(hudIdleImg);
        setIsScoreChanging(false);
      }, changeDurationMs);
    }

    prevScoreRef.current = score;
    return () => scoreTimeoutRef.current && clearTimeout(scoreTimeoutRef.current);
  }, [score, changeDurationMs]);


  const [timerHudSrc, setTimerHudSrc] = useState(hudTimerIdle);
  const prevTimeRef = useRef(timeLeft);
  const toggleRef = useRef(false);

  useEffect(() => {
    if (timeLeft > timerAlertThreshold || timeLeft <= 0) {
      setTimerHudSrc(hudTimerIdle);
      toggleRef.current = false;
    } else if (timeLeft !== prevTimeRef.current) {
      toggleRef.current = !toggleRef.current;
      setTimerHudSrc(toggleRef.current ? hudTimerAlert : hudTimerIdle);
    }

    prevTimeRef.current = timeLeft;
  }, [timeLeft, timerAlertThreshold]);


  return (
    <header className="tb-topbar">
      
   



       {/* SCORE HUD */}
      <div className="tb-hud-box">
        <img
          src={hudSrc}
          alt=""
          className="tb-hud-img"
        style={{
            // 1. Logic moved here so it works without external CSS
            transform: isScoreChanging ? "scale(1.1)" : "scale(1)",
            
            // 2. Smooth bouncy transition
            transition: "transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
            
            // 3. Safety: Prevents Card.css 'max-width: 100%' from stopping the growth
            maxWidth: "none", 
            maxHeight: "none"
          }}
        />
        <div className="tb-hud-text">{score}</div>
      </div>


      {/* TITLE */}
      <div className="tb-title">{title}</div>

      {/* TIMER HUD */}
      <div className="tb-timer-box">
        <img src={timerHudSrc} alt="" className="tb-timer-img" />
        <div className="tb-timer-text">{timeLeft}s</div>
      </div>

    </header>
  );
}
